"use client";

import { useEffect } from "react";

import { WithChildren } from "@/src/types/generic-react-props";

/**
 * Wrapper component for error pages that intercepts all navigation and forces
 * full page reloads instead of client-side navigation.
 *
 * Ensures users can always navigate away from error pages by forcing full reloads.
 */
const ErrorNavigationWrapper = ({ children }: WithChildren) => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!(e.target instanceof HTMLElement)) return;

      const link = e.target.closest("a");
      if (link?.href.startsWith(window.location.origin)) {
        e.preventDefault();
        window.location.href = link.href;
      }
    };

    document.addEventListener("click", handleClick, true);
    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, []);

  return children;
};

export default ErrorNavigationWrapper;
